import { GiTennisBall } from 'react-icons/gi';
import { UserPlus } from 'lucide-react';
import { Player } from '../types';

interface HeaderProps {
  user: Player | null;
  onLoginClick: () => void;
  onRegisterClick: () => void; // Added this prop
  onEditProfile: () => void;
  onLogoutClick: () => void;
  onAddFriendClick: () => void;
  notifications: any[]; // Adjusted type for simplicity
  onMarkNotificationAsRead: (notificationId: string) => void;
  onClearAllNotifications: () => void;
  onAdminPanelClick: () => void;
}

export default function Header({
  user,
  onLoginClick,
  onRegisterClick, // Added this prop
  onEditProfile,
  onLogoutClick,
  onAddFriendClick,
  notifications,
  onMarkNotificationAsRead,
  onClearAllNotifications,
  onAdminPanelClick
}: HeaderProps) {
  const handleLogoClick = () => {
    window.location.href = '/';
  };

  return (
    <header className="header bg-white shadow">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          <div className="flex items-center gap-4">
            <div
              className="flex items-center gap-2 cursor-pointer hover:opacity-80"
              onClick={handleLogoClick}
            >
              <GiTennisBall className="w-8 h-8 text-blue-600" />
              <h1 className="text-xl font-bold text-gray-900">
                WannaPlay
              </h1>
            </div>
            {user?.is_admin && (
              <button
                onClick={onAdminPanelClick}
                className="bg-blue-100 text-blue-600 px-3 py-1 rounded-md hover:bg-blue-200"
              >
                Admin Panel
              </button>
            )}
          </div>
          <div className="flex items-center gap-4">
            {user ? (
              <>
                <button
                  onClick={onAddFriendClick}
                  className="flex items-center gap-2 px-3 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
                >
                  <UserPlus className="w-4 h-4" />
                  Add Friends
                </button>
                <button onClick={onEditProfile}>Edit Profile</button>
                <button onClick={onLogoutClick}>Logout</button>
              </>
            ) : (
              <>
                <button onClick={onLoginClick}>Login</button>
                <button onClick={onRegisterClick}>Register</button>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}